import { axios } from '@/utils/request'

export function getReportDay(parameter = {}) {
  return axios({
    url: '/reportDay/list',
    method: 'post',
    data: parameter
  })
}

